module.exports = __webpack_public_path__ + "static/img/bulk-not-uploaded@2x.d95c9929.png";